<p class="page-sub-title">Future Dollars</p>
<div class="modal-close" (click)="onClose()">
    <img alt="Close" src="../../../assets/icons/circle-x.svg" />
</div>
<p>
    Future dollars illustrates what these expected costs will be when factoring in expected increases due to inflation.
</p>